<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="success" @click="updateStatus(1)">确认</el-button>
        <el-button type="warning" @click="updateStatus(0)">取消确认</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button type="text" @click="editById(row.Junior9Id)" v-if="$permission.canWrite()&&row.Status!=3">编辑</el-button>
            <el-button type="text" @click="detailsById(row.Junior9Id)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <view-dialog ref="viewDialog" @close-saved="reload" />
    <parent-dialog ref="parentDialog" in-dialog selectable @select="setParent" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/po/hwreport/list";
import editDialog from "@/components/po/hwreport/editDialog";
import viewDialog from "@/components/po/hwreport/viewDialog";
import parentDialog from "@/components/po/parent/listDialog";

export default {
  name: "",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    viewDialog,
    parentDialog,
  },
  data() {
    return {
      api: require("@/api/po/junior9").default,
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    detailsById(id) {
      this.$refs.viewDialog.openDetailsById(id);
    },
    create() {
      this.$refs.parentDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setParent(e) {
      var obj = {
        ParentId: e.ParentId,
        IdCard: e.StudentIdCard,
        Mobile: e.Mobile,
      };
      this.$refs.editDialog.openCreate(obj);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.Junior9Id;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    updateStatus(Status) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要操作的数据");
        return;
      }
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let Ids = rows.map((item) => {
            return item.Junior9Id;
          });
          this.api.updateStatus({ Ids, Status }).then(res => {
            if(res.Code==0) {
              this.$refs.list.reload();
              this.$message.success(res.Msg);
            } else this.$message.error(res.Msg);
          })
        })
        .catch(() => {});
    },
  }
};
</script>